import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id 6E4368BF-7150-40D2-861B-375421A7774B
 * name map-marker-down
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-down.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const MapMarkerDownIcon = createSvgIcon(<><path d="M12 2A7 7 0 0 0 5 9C5 14.25 12 22 12 22S19 14.25 19 9A7 7 0 0 0 12 2M7.5 10H10V5H14V10H16.5L12 14.5Z" /></>, 'MapMarkerDownIcon');
export default MapMarkerDownIcon